import { useState, useEffect } from "react";
import { KeyVal, SubContainer } from "../Layouts";
import { getGatewayDeviceList } from "../../api/gateway";
import { useParams } from "react-router-dom";
import { parseQuery } from "../../utils";
import { Input, Table } from "antd";

export default function GatewayDetail() {
    const { gatewayMac } = useParams()
    const [localDevices, setLocalDevices] = useState<string[]>([])
    const [remoteDevices, setRemoteDevices] = useState<string[]>([])
    useEffect(() => {
        getGatewayDeviceList(gatewayMac as string)
            .then(res => {
                setLocalDevices(res?.localDevices || [])
                setRemoteDevices(res?.remoteDevices || [])
            })
    }, [gatewayMac])
    return (
        <div>
            <SubContainer style={{ background: 'transparent', textAlign: 'center' }}>
                <h3>{parseQuery(window.location.search).gatewayName}</h3>
                <KeyVal name="网关MAC地址" value={gatewayMac} />
            </SubContainer>
            <SubContainer style={{ background: 'transparent' }}>
                <DiifList localDevices={localDevices || []} remoteDevices={remoteDevices || []} />
            </SubContainer>
        </div>
    )
}
const List = ({ items, title }: { items: string[], title: string }) => {
    return (
        <div style={{
            display: 'flex', flexDirection: 'column', flex: 1, textAlign: 'center'
        }}>
            <br />
            <Table pagination={false} size='small' columns={[{key: 'mac', dataIndex: 'mac', title: `${title}(${items.length})`}]} dataSource={items.map(i => {
                return {
                    mac: i
                }
            })}  />
        </div>
    )
}

const DiifList = ({ localDevices, remoteDevices }: { localDevices: string[], remoteDevices: string[] }) => {
    const [filter, setFilter] = useState('');
    const _localDevices = [...localDevices].sort().filter(i => {
        return i.toUpperCase().includes(filter.toUpperCase())
    });
    const _remoteDevices = [...remoteDevices].sort().filter(i => {
        return i.toUpperCase().includes(filter.toUpperCase())
    });
    return (
        <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            width: 400, margin: '0 auto'
        }}>
            <Input value={filter} onChange={e => { setFilter(e.target.value) }} placeholder="请输入设备序列号" style={{ width: '100%' }} />
            <section style={{ display: 'flex', gap: 20, width: '100%' }}>
                <List items={_localDevices} title="本地设备列表" />
                <List items={_remoteDevices} title="远程设备列表" />
            </section>
        </div>
    )
}
